import * as React from 'react';

interface Props {
  errorMessage: string;
}

const failure = (props: Props) => {
  const style = {
    color: 'red'
  };
  return (
    <div style={style}>
      <span>{props.errorMessage}</span>
      <span className="icon">
        <i className="fas fa-times" />
      </span>
    </div>
  );
};

export default failure;



// WEBPACK FOOTER //
// ./src/components/Failure.tsx